import Cookies from 'js-cookie'

export function maybeArr(arr) {
  return Boolean(Array.isArray(arr) && arr.length)
}

export function maybeObj(obj) {
  return (
    Object.keys(obj).length &&
    obj.constructor === Object &&
    typeof obj === `object`
  )
}

// Usage: cls(`block-set-item`, {'--col': isCol}, cls)
export function cls(baseClass, conditions = {}, addCls = ``) {
  if (!(baseClass || maybeObj(conditions))) return null

  const classNames = [baseClass]

  Object.keys(conditions).forEach((condition) => {
    if (conditions[condition]) {
      classNames.push(condition)
    }
  })

  if (addCls) {
    classNames.push(addCls)
  }

  return classNames.join(` `)
}

export function bgUrlStyle(url) {
  return url && {backgroundImage: `url('${url}')`}
}

export function maybeText(text) {
  if (!text) return null

  if (maybeArr(text)) {
    return text.join(` `)
  }

  return text
}

export function setCookies({name, value, options}) {
  const isSecure = window.location.protocol === `https:`
  return Cookies.set(
    name,
    value,
    options || (isSecure && {sameSite: `none`, secure: isSecure})
  )
}

export function getCookies(name) {
  return Cookies.get(name)
}

export function backendApiRoot(path) {
  return !path ? null : `${process.env.NEXT_PUBLIC_BACKEND_API_ROOT}${path}`
}

export function bool(val) {
  return Boolean(val)
}

export function unique(array) {
  return [...new Set(array.map(JSON.stringify))].map(JSON.parse)
}

export const setQueryParam = ({query, navigate, type, name}) => {
  query.set(type, name)
  navigate({search: query.toString()}, {replace: true})
}
